var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("rb-text-module", {
    staticClass: "rb-no-results",
    attrs: {
      "text-align": "center",
      "content-position": "center",
      theme: "dark",
    },
    scopedSlots: _vm._u([
      {
        key: "title_block",
        fn: function () {
          return [
            _c("h2", { staticClass: "rb-no-results__title" }, [
              _vm._v(_vm._s(_vm.$t("plp.product_not_found.title"))),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "excerpt_block",
        fn: function () {
          return [
            _c("p", { staticClass: "rb-no-results__subtitle" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("plp.product_not_found.subtitle")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "cta_block",
        fn: function () {
          return _vm._l(_vm.buttons, function (b, i) {
            return _c(
              "a",
              {
                key: i,
                staticClass: "rb-btn rb-btn--black",
                attrs: { "data-element-id": b.track, href: b.url },
              },
              [_vm._v("\n      " + _vm._s(b.label) + "\n    ")]
            )
          })
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }